import React, { useState } from 'react';
import { Button } from 'src/skins/common/components/Button';
import { TextInput } from 'src/skins/pluto/components/inputs';
import { useForm } from 'react-hook-form';
import { useDispatch, useSelector } from 'react-redux';
import { formatToDigits } from 'src/utils/helpers';
import { requestForgot } from 'src/store/actions/userActions';
import { AccountVerificationModal } from 'src/skins/pluto/modals';

export const ForgotPasswordForm = () => {
  const dispatch = useDispatch();
  const [phoneData, setPhoneData] = useState('');
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const platform = useSelector(state => state.MMO.shortCode);
  const { isLoading } = useSelector(state => state.USER);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const toggleModal = () => {
    setModalIsOpen(!modalIsOpen);
  };

  const onSubmit = data => {
    const { phoneNumber } = data;

    dispatch(
      requestForgot(phoneNumber, success => {
        setPhoneData(+phoneNumber);
        success && toggleModal();
      })
    );
  };

  return (
    <>
      <form onSubmit={handleSubmit(onSubmit)}>
        <div>
          <TextInput
            type="tel"
            label="Phone Number"
            name="phoneNumber"
            ref={register({ required: true })}
            icon="phone"
            inputmode="numeric"
            pattern="[0-9]*"
            onInput={e => {
              e.target.value = formatToDigits(e.target.value, 11);
            }}
            errors={
              <React.Fragment>{errors.phoneNumber && <p className="error">Phone number is required</p>}</React.Fragment>
            }
          />
        </div>

        <br />

        <Button type="submit" text="Send Reset Code" size="large" isLoading={isLoading.requestForgot} />
      </form>

      <AccountVerificationModal
        userData={{ phoneNumber: phoneData, platform }}
        isOpen={modalIsOpen}
        closeModal={toggleModal}
      />
    </>
  );
};

export default ForgotPasswordForm;
